import { create } from 'zustand';

/**
 * Store for map interaction/UI state - local to the Map component tree
 * This replaces MapContext
 */
const useMapInteractionStore = create((set, get) => ({
  // Filter state
  activeCategoryFilter: [],
  setActiveCategoryFilter: (activeCategoryFilter) => set({ activeCategoryFilter }),

  activeFilterSelections: {},
  setActiveFilterSelections: (activeFilterSelections) => set({ activeFilterSelections }),

  activeFloorPlanUuids: [],
  setActiveFloorPlanUuids: (activeFloorPlanUuids) => set({ activeFloorPlanUuids }),

  activeLevelOfCareUuid: null,
  setActiveLevelOfCareUuid: (activeLevelOfCareUuid) => set({ activeLevelOfCareUuid }),

  filteredCategoryData: {},
  setFilteredCategoryData: (filteredCategoryData) => set({ filteredCategoryData }),

  // Level/tier state
  activeLevelTid: null,
  setActiveLevelTid: (activeLevelTid) => set({ activeLevelTid }),

  // Media types
  amenityMediaTypes: [],
  setAmenityMediaTypes: (amenityMediaTypes) => set({ amenityMediaTypes }),

  // Unit data
  changedUnits: [],
  setChangedUnits: (changedUnits) => set({ changedUnits }),

  mapActiveUnitData: {},
  setMapActiveUnitData: (mapActiveUnitData) => set({ mapActiveUnitData }),

  // Google Map instance and state
  map: null,
  setMap: (map) => set({ map }),

  mapIdle: false,
  setMapIdle: (mapIdle) => set({ mapIdle }),

  isZooming: false,
  setIsZooming: (isZooming) => set({ isZooming }),

  // Visibility state
  overlayVisible: true,
  setOverlayVisible: (overlayVisible) => set({ overlayVisible }),

  levelsControlVisible: false,
  setLevelsControlVisible: (levelsControlVisible) => set({ levelsControlVisible }),

  markersVisible: false,
  setMarkersVisible: (markersVisible) => set({ markersVisible }),

  // Overlay state
  overlayView: null,
  setOverlayView: (overlayView) => set({ overlayView }),

  overlayBounds: null,
  setOverlayBounds: (overlayBounds) => set({ overlayBounds }),

  // Focus coordinates
  focusLatLng: null,
  setFocusLatLng: (focusLatLng) => set({ focusLatLng }),

  focusXYZ: null,
  setFocusXYZ: (focusXYZ) => set({ focusXYZ }),

  // External location focus (TourGuideAi location-based results)
  externalLocations: [],
  setExternalLocations: (externalLocations) => set({ externalLocations }),

  externalMarker: null,
  setExternalMarker: (externalMarker) => set({ externalMarker }),

  externalMarkers: [],
  setExternalMarkers: (externalMarkers) => set({ externalMarkers }),

  isExternalFocus: false,
  setIsExternalFocus: (isExternalFocus) => set({ isExternalFocus }),

  // Route directions renderer + travel time for external location
  routeRenderer: null,
  setRouteRenderer: (routeRenderer) => set({ routeRenderer }),

  routeRenderers: [],
  setRouteRenderers: (routeRenderers) => set({ routeRenderers }),

  travelTimeOverlay: null,
  setTravelTimeOverlay: (travelTimeOverlay) => set({ travelTimeOverlay }),

  travelTimeOverlays: [],
  setTravelTimeOverlays: (travelTimeOverlays) => set({ travelTimeOverlays }),

  // Reset state (may overlap with mapStateStore.resetMap)
  resetMap: false,
  setResetMap: (resetMap) => set({ resetMap }),

  // Flag to indicate component is inside map tree
  isInsideMap: false,
  setIsInsideMap: (isInsideMap) => set({ isInsideMap }),

  // Result floor plans (used by ResidenceFilterContent)
  resultFloorPlans: null,
  setResultFloorPlans: (resultFloorPlans) => set({ resultFloorPlans }),

  // Valid floor plan UUIDs (used by ResidenceFilterContent)
  validFloorPlanUuids: [],
  setValidFloorPlanUuids: (validFloorPlanUuids) => set({ validFloorPlanUuids }),

  // Pre-formatted filter data (used by ResidenceFilterContent)
  preFormattedFilterData: null,
  setPreFormattedFilterData: (preFormattedFilterData) => set({ preFormattedFilterData }),

  // Reset all filter selections
  resetSelections: () => set({
    activeFilterSelections: {},
  }),
}));

export default useMapInteractionStore;
